import { defineMessages } from 'react-intl';

export const newMessagesNotificationMessages = defineMessages({
	new_messages_notification_body: {
		id: 'notification.new_messages.body',
		defaultMessage:
			'You have {count, plural, one {{count} new message} other {{count} new messages}}',
		description: "New messages Notification's text content",
	},
	new_messages_notification_body_generic: {
		id: 'notification.new_messages.body_generic',
		defaultMessage: 'You have new messages',
		description: "New messages Notification's text content",
	},
	new_messages_notification_title: {
		id: 'notification.new_messages.title',
		defaultMessage: 'New messages',
		description: 'New messages Notification title',
	},
});
